export const ADMIN_TOKEN_SESSION_KEY = 'gymgpt.adminToken';

export type AdminUnauthorizedReason = 'expired' | 'disabled';

type AdminUnauthorizedListener = (reason: AdminUnauthorizedReason) => void;

const listeners = new Set<AdminUnauthorizedListener>();

export function readAdminToken(): string | null {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_SESSION_KEY);
  } catch {
    return null;
  }
}

export function writeAdminToken(token: string): void {
  try {
    sessionStorage.setItem(ADMIN_TOKEN_SESSION_KEY, token);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function clearAdminToken(): void {
  try {
    sessionStorage.removeItem(ADMIN_TOKEN_SESSION_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function subscribeAdminUnauthorized(listener: AdminUnauthorizedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyAdminUnauthorized(reason: AdminUnauthorizedReason): void {
  clearAdminToken();
  for (const listener of listeners) {
    listener(reason);
  }
}
